var t = {
  left: "lib:right-4 lib:top-4 lib:md:left-[calc(100%+1rem)] lib:md:top-6 ",
  right: "lib:right-4 lib:top-4 lib:md:right-[calc(100%+1rem)] lib:md:top-6",
  top: "lib:right-4 lib:top-4",
  bottom: "lib:right-4 lib:top-4"
};
export {
  t as closeButtonClassNames
};
